var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "full_layout information",
      attrs: { id: "Information" }
    },
    [
      _c("h3", { staticClass: "informationTitle" }, [
        _vm._v(_vm._s(_vm.$t("DakaNews")))
      ]),
      _vm._v(" "),
      _vm.list != null
        ? _c(
            "ul",
            { staticClass: "informationList" },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "li",
                { key: index },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "space_between",
                      attrs: {
                        to: {
                          path:
                            "/info/item/" +
                            item._id +
                            "?i=" +
                            index +
                            "&p=" +
                            _vm.pi
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "informationImg" }, [
                        _c("img", {
                          attrs: { src: item.ImgUrl + "?imageView2/2/w/200" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "informationText" }, [
                        _c("div", { staticClass: "textTitle" }, [
                          _vm._v(_vm._s(item.Title))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "line_txt3" }, [
                          _vm._v(_vm._s(_vm._f("setContent")(item.ContentText)))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "textTime" }, [
                          _vm._v(_vm._s(item.ReleaseTime))
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.list != null
        ? _c("pagination", {
            attrs: { TotalCount: _vm.TotalCount, ps: _vm.ps },
            on: { ps: _vm.pageSize, pi: _vm.pageIndex }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-979aa64a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-979aa64a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/information/index.vue
// module id = null
// module chunks = 